"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOADER_TYPES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require("@vtex/styleguide/lib/Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _LinearProgress = require("@material-ui/core/LinearProgress");

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

var _styles = require("@material-ui/core/styles");

require("./global.css");

var _ImageResizer = require("../ImageResizer");

var _ImageResizer2 = _interopRequireDefault(_ImageResizer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {
  barColorPrimary: {
    backgroundColor: 'currentColor'
  }
};
var LinearProgressWithStyle = (0, _styles.withStyles)(styles)(_LinearProgress2["default"]);
var LOAD_STATES = {
  LOADING: 'LOADING',
  TRANSITION: 'TRANSITION',
  LOADED: 'LOADED'
};
var imageMinRatio = 2 / 3;
var LOADER_TYPES = exports.LOADER_TYPES = {
  SPINNER: 'SPINNER',
  LINEAR: 'LINEAR'
};

var BlurredLoader = /*#__PURE__*/function (_React$Component) {
  _inherits(BlurredLoader, _React$Component);

  function BlurredLoader(props) {
    var _this;

    _classCallCheck(this, BlurredLoader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlurredLoader).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "generateImage", function (urlIndex) {
      var realUrls = _this.props.realUrls;
      var realUrlIndex = _this.state.realUrlIndex;
      var bestUrlIndex = urlIndex || _this.props.bestUrlIndex;

      if (realUrlIndex && bestUrlIndex <= realUrlIndex) {
        return;
      }

      var hdImageLoader = new Image();
      hdImageLoader.src = realUrls[bestUrlIndex];

      hdImageLoader.onerror = function () {
        var realUrlIndex = _this.state.realUrlIndex;
        if (!realUrlIndex) realUrlIndex = 0;
        if (_this.loadCounter > 10) return;
        _this.loadCounter++;

        _this.generateImage(Math.max(bestUrlIndex - 1, realUrlIndex));
      };

      hdImageLoader.onload = function () {
        var realUrlIndex = _this.state.realUrlIndex;
        if (realUrlIndex && bestUrlIndex <= realUrlIndex) return;

        _this.setState({
          loadState: LOAD_STATES.TRANSITION,
          realUrlIndex: bestUrlIndex
        });

        var timer = setTimeout(function () {
          _this.setState({
            loadState: LOAD_STATES.LOADED
          });

          _this.props.onload && _this.props.onload();
          delete _this.timers[timer];
        }, 1000);
        _this.timers[timer] = true;

        if (_this.props.bestUrlIndex > bestUrlIndex) {
          _this.generateImage();
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "Loader", function () {
      var loaderType = _this.props.loaderType;
      var loadState = _this.state.loadState;

      switch (loaderType) {
        case LOADER_TYPES.LINEAR:
          return _react2["default"].createElement("div", {
            className: "w-100 top-0 z-2 absolute transition-opacity-1 ".concat(loadState === LOAD_STATES.LOADING ? 'o-100' : 'o-0')
          }, _react2["default"].createElement(LinearProgressWithStyle, {
            className: "c-action-primary"
          }));

        case LOADER_TYPES.SPINNER:
          return _react2["default"].createElement("div", {
            className: "absolute z-2 center-all left-0 right-0 top-0 bottom-0 transition-opacity-1 ".concat(loadState === LOAD_STATES.LOADING ? 'o-100' : 'o-0'),
            style: {
              height: 40,
              width: 40
            }
          }, _react2["default"].createElement(_Spinner2["default"], null));

        default:
          return null;
      }
    });

    _this.state = {
      loadState: LOAD_STATES.LOADING,
      realUrlIndex: null
    };
    _this.timers = {};
    _this.loadCounter = 0;
    return _this;
  }

  _createClass(BlurredLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.generateImage();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;

      var keys = Object.keys(this.timers);
      keys.forEach(function (key) {
        return _this2.timers[key] && clearTimeout(key);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var Loader = this.Loader;
      var _this$props = this.props,
          className = _this$props.className,
          alt = _this$props.alt,
          loaderUrl = _this$props.loaderUrl,
          realUrls = _this$props.realUrls;
      var _this$state = this.state,
          loadState = _this$state.loadState,
          realUrlIndex = _this$state.realUrlIndex;
      var loaded = loadState === LOAD_STATES.LOADED;
      return _react2["default"].createElement(_react2["default"].Fragment, null, _react2["default"].createElement(_ImageResizer2["default"], {
        className: "w-100 ".concat(loaded ? 'db' : 'dn'),
        alt: alt,
        src: realUrls[realUrlIndex],
        minRatio: imageMinRatio
      }), !loaded && _react2["default"].createElement("div", {
        className: "relative w-100 db"
      }, _react2["default"].createElement(Loader, null), _react2["default"].createElement(_ImageResizer2["default"], {
        alt: alt,
        src: loaderUrl,
        minRatio: imageMinRatio,
        className: "w-100 blur-30 transition-opacity-1 db z-2 o-100 ".concat(className)
      }), _react2["default"].createElement(_ImageResizer2["default"], {
        alt: "",
        src: realUrls[realUrlIndex],
        minRatio: imageMinRatio,
        className: "absolute z-1 w-100 center left-0 right-0 bottom-0 top-0 transition-opacity-1 db ".concat(loadState === LOAD_STATES.LOADING ? 'o-0' : 'o-100')
      })));
    }
  }]);

  return BlurredLoader;
}(_react2["default"].Component);

BlurredLoader.propTypes = {
  className: _propTypes2["default"].string,
  alt: _propTypes2["default"].string,
  loaderUrl: _propTypes2["default"].string.isRequired,
  realUrls: _propTypes2["default"].arrayOf(_propTypes2["default"].string).isRequired,
  thresholds: _propTypes2["default"].arrayOf(_propTypes2["default"].number),
  onload: _propTypes2["default"].func,
  bestUrlIndex: _propTypes2["default"].number,
  loaderType: _propTypes2["default"].oneOf([LOADER_TYPES.SPINNER, LOADER_TYPES.LINEAR])
};
BlurredLoader.defaultProps = {
  thresholds: []
};
exports["default"] = BlurredLoader;